import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkOrdersService } from '../../../services/work-orders.service';

@Component({
  selector: 'app-view-work-order',
  templateUrl: './view-work-order.component.html',
  styleUrl: './view-work-order.component.scss'
})
export class ViewWorkOrderComponent {

  workOrder: any;

  constructor(
    private route: ActivatedRoute,
    private workOrderService: WorkOrdersService
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.getWorkOrder(id);
  }

  getWorkOrder(id: string | null): void {
    if (id) {
      this.workOrderService.getById(Number(id)).subscribe((data: any) => {
        this.workOrder = data.data;
      });
    }
  }


  isDownloadingPdf = false;

  downloadPdf(): void {
    if (this.isDownloadingPdf || !this.workOrder) return;

    this.isDownloadingPdf = true;
    this.workOrderService.downloadPdf(this.workOrder.id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `OrdenTrabajo_${this.workOrder.id}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.isDownloadingPdf = false;
      },
      error: (error: any) => {
        console.error('Error downloading PDF:', error);
        this.isDownloadingPdf = false;
      }
    });
  }
}
